import React from "react";
import NavbarBtns from "./NavbarBtns";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaWindowClose,
} from "react-icons/fa";
import { RiCloseCircleLine } from "react-icons/ri";
const Navbar = () => {
  return (
    <div className="ms-1 ">
      <button
        style={{
          position: "fixed",
          zIndex: 100,

          boxShadow: "2px 3px 10px #f5f5f5",
        }}
        className="btn btn-dark border-white ms-1 mt-2 "
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      >
        <GiHamburgerMenu />
      </button>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        {/* Beautiful floating close button */}
        <button
          type="button"
          className="position-absolute top-50 start-100  translate-middle d-flex align-items-center justify-content-center border-0 rounded-circle shadow-sm"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          style={{
            width: "36px",
            height: "36px",
            background: "rgba(255, 255, 255, 0.95)",
            color: "#333",
            zIndex: 1050,
            fontSize: "20px",
            lineHeight: 1,
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#f72525";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "rgba(5, 5, 5, 0.95)";
          }}
        >
          <FaArrowAltCircleLeft />
        </button>

        {/* Navbar starts from the very top */}
        <div className="offcanvas-body pt-1 p-1">
          <NavbarBtns />
        </div>
      </div>
    </div>
  );
};
export default Navbar;
